import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { FooterStyle } from '../../store/interfaces';
export const FooterStyles = makeStyles((theme: Theme) =>
  createStyles({
    footer: (props: FooterStyle) => ({
      zIndex: 102,
      backgroundColor: props.backgroundColor,
      color: props.textColor,
      justifyContent: 'center',
      height: '165px',
      padding: '0 15px',
      [theme.breakpoints.up('md')]: {
        padding: '0 80px',
      },
      [theme.breakpoints.up('lg')]: {
        height: '97px',
      },
      [theme.breakpoints.up('xl')]: {
        padding: '0 113px',
      },
    }),
    journeyTheme: {
      display: 'none',

      [theme.breakpoints.up('lg')]: {
        display: 'block',
        position: 'fixed',
        bottom: '0',
        width: '100%',
      },
    },
    footerButton: (props: FooterStyle) => ({
      border: '2px solid',
      fontWeight: 600,
      color: props.helpButton.textColor,
      backgroundColor: props.helpButton.fillColor,
      borderColor: props.helpButton.outlineColor,
      '&:hover, &:active': {
        /** check for solid button and inverted case */
        border: '2px solid',
        color: props.helpButton.fillColor,
        borderColor:
          props.helpButton.outlineColor === props.helpButton.fillColor
            ? props.helpButton.textColor
            : props.helpButton.outlineColor,
        backgroundColor: props.helpButton.textColor,
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '0.75rem',
        padding: '2px 15px',
      },
    }),
    copyRightText: {
      fontWeight: 'normal',
      marginBottom: '24px',
      '& svg': {
        fontSize: 'inherit',
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '0.75rem',
        marginBottom: '16px',
      },
    },
    utilityLink: (props: FooterStyle) => ({
      paddingLeft: 0,
      marginBottom: '8px',
      '& > li:not(:last-child)': {
        marginRight: '30px',
      },
      '& a': {
        color: props.textColor,
        textDecoration: 'none',
        fontWeight: 'bold',
        '&:visited': {
          textDecoration: 'none',
          color: props.textColor,
        },
      },
    }),
  }),
);
